module.exports = __webpack_public_path__ + "images/arrowsIcon-7aa90a.svg";